import React, { useState } from "react"
import { BuildConfiguration } from "../../services/platform-info/build-configuration"
import { useActiveViewerQuery } from "../../screens/ActiveItems/queries.generated"
import { ErrorMessage, TouchButton } from "pusatec-react-native"
import { useUseLainaamoCodeMutation } from "./queries.generated"

interface Props {
	code: string
	onConfirm(): void
}

export default function DebugConfirming(props: Props) {
	const { code, onConfirm } = props

	const [error, setError] = useState<any>(null)
	const [loading, setLoading] = useState<boolean>(false)

	const { refetch } = useActiveViewerQuery()
	const [useLainaamoCodeMutation] = useUseLainaamoCodeMutation()

	if (
		BuildConfiguration.ENV === "development" ||
		BuildConfiguration.ENV === "staging"
	) {
		return (
			<>
				{error && <ErrorMessage message="" extra={error} />}
				<TouchButton
					type="secondary"
					text="Confirm usage (debug)"
					loading={loading}
					onPress={async () => {
						if (loading) return

						setLoading(true)
						try {
							const { errors } = await useLainaamoCodeMutation({
								variables: {
									code,
								},
							})
							if (errors && errors.length) {
								throw errors[0]
							}

							await refetch()
							setError(null)
							onConfirm()
						} catch (error) {
							console.log("error", error)
							setError(error)
						} finally {
							setLoading(false)
						}
					}}
				/>
			</>
		)
	}
	return null
}
